import React from 'react';
import ErrorMessage from "../../components/ErrorMessage";
import HomeScreen from "../homescreen/homescreen";
import LoadingComponent from "../../components/Loading";
import PhotoViewer from "../../components/PhotoViewer";
import Service from "../../service/service";
import './styles.css';

class Gallery extends HomeScreen {

    state = {
        loading: true,
        errorMessage: null,
        galleryNotFound: false,
        galleryItems: [],
        selectedImage: null,
    };

    service = new Service();

    queryParams = new URLSearchParams(window.location.search);

    componentDidMount() {
        this.setState(this.state);
        const galleryId = this.queryParams.get('gallery');
        if (galleryId) {
            this.loadGallery(galleryId);
        } else {
            this.loadGallery("home");
        }
    }

    loadGallery(galleryId) {
        this.state.loading = true;
        this.state.errorMessage = null;
        this.state.galleryNotFound = false;
        this.state.galleryItems = [];
        this.setState(this.state);

        this.service.loadGallery(galleryId)
            .then(result => {
                this.state.galleryItems = result.data;
                this.state.loading = false;
                this.setState(this.state);
            }).catch(error => {
                console.log(error);
                if (error.response && error.response.status === 404) {
                    this.state.galleryNotFound = true;
                    this.state.errorMessage = "Gallery not found";
                } else {
                    this.state.errorMessage = "There was an error loading the gallery";
                }
                this.state.loading = false;
                this.setState(this.state);
            });
    }

    renderHomeContent() {
        const {galleryItems, errorMessage, loading, selectedImage} = this.state;
        return (
            <div>
                <ErrorMessage errorMessage={errorMessage} />
                {selectedImage &&
                    <PhotoViewer
                        imageSrc={selectedImage}
                        closeGalleryCallback={this.closeGalleryItem}
                    />
                }
                <LoadingComponent isLoading={loading} />

                <div className='galleryContainer'>
                    {galleryItems.map(item => this.mapGalleryItemToView(item))}
                </div>


            </div>
        );
    }

    mapGalleryItemToView(item) {
        const isInternalGallery = item.galleryId !== null && item.galleryId !== undefined;
        const isExternalGallery = item.galleryUrl !== null && item.galleryUrl !== undefined;
        const isGallery = isInternalGallery || isExternalGallery;

        const galleryUri = isInternalGallery ? `/gallery?gallery=${item.galleryId}` : item.galleryUrl;
        return (
            <div className='galleryItem' onClick={(e) => this.onGalleryItemSelected(item) }>
                {isGallery &&
                    <a href={galleryUri}>
                        {this.mapGalleryItemThumbnailView(item)}
                    </a>
                }
                {!isGallery && this.mapGalleryItemThumbnailView(item)}
            </div>
        );
    }

    mapGalleryItemThumbnailView(item) {
        return (
            <div className='galleryItemInnerContainer'>
                {item.name && <span className='galleryItemTitle'>{item.name}</span>}
                <img src={item.thumbnail} />
            </div>
        );
    }

    getScreenName() {
        return 'Gallery';
    }

    onGalleryItemSelected = (galleryItem) => {

        if (true) {
            window.location = `/gallery_viewer?photo=${galleryItem.imageSrc}`;
            return;
        }
        const isInternalGallery = galleryItem.galleryId !== null && galleryItem.galleryId !== undefined;
        const isExternalGallery = galleryItem.galleryUrl !== null && galleryItem.galleryUrl !== undefined;
        if (isInternalGallery || isExternalGallery) {
            return;
        }

        if (galleryItem.galleryId) {
            this.props.location.push(`gallery?gallery=${galleryItem.galleryId}`)
            this.loadGallery(galleryItem.galleryId);
        } else {
            this.state.selectedImage = galleryItem.imageSrc || galleryItem.thumbnail;
            this.setState(this.state);
        }
        console.log(galleryItem.galleryId);

    };

    closeGalleryItem = () => {
        this.state.selectedImage = null;
        this.setState(this.state);
    };
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/screens/gallery/index.js